import { randRange } from '../utils/math.js';

/**
 * Lightweight particle bursts + ambient sparkles.
 */
export default class ParticleSystem {
  constructor() {
    this.particles = [];
  }

  reset() {
    this.particles.length = 0;
  }

  burst(x, y, { count = 18, hue = 185, speed = 0.35, life = 0.7 } = {}) {
    for (let i = 0; i < count; i++) {
      const a = (Math.PI * 2 * i) / count + randRange(-0.2, 0.2);
      const s = speed * randRange(0.4, 1.2);
      this.particles.push({
        x,
        y,
        vx: Math.cos(a) * s,
        vy: Math.sin(a) * s,
        life,
        maxLife: life,
        size: randRange(0.004, 0.012),
        hue: hue + randRange(-18, 18),
        drag: 0.92
      });
    }
  }

  sparkle(x, y, hue = 300) {
    this.particles.push({
      x,
      y,
      vx: randRange(-0.05, 0.05),
      vy: randRange(-0.08, 0.02),
      life: randRange(0.4, 0.9),
      maxLife: 0.9,
      size: randRange(0.003, 0.008),
      hue,
      drag: 0.96
    });
  }

  update(dt) {
    for (const p of this.particles) {
      p.x += p.vx * dt;
      p.y += p.vy * dt;
      p.vx *= p.drag;
      p.vy *= p.drag;
      p.life -= dt;
    }
    this.particles = this.particles.filter((p) => p.life > 0);
  }

  getActive() {
    return this.particles;
  }
}
